module.exports = __webpack_public_path__ + "static/media/16.12c1cca9.jpg";